import {Create} from 'react-admin';

const CreateMod = props => {
    return (<Create {...props} redirect="/admins" ></Create>);
};

export default CreateMod;
